import {CreateInstance} from './config'
const CheckAPI = CreateInstance('check')
export default CheckAPI
